import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-8" }
const _hoisted_2 = { class: "text-center mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-800 mb-4" }
const _hoisted_4 = { class: "space-y-6" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = { class: "flex-shrink-0 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg mr-6" }
const _hoisted_7 = { class: "flex-1 bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow" }
const _hoisted_8 = { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-3" }
const _hoisted_9 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_10 = { class: "bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium" }
const _hoisted_11 = { class: "text-lg font-medium text-blue-600 mb-2" }
const _hoisted_12 = { class: "text-gray-600 mb-4" }
const _hoisted_13 = { class: "flex flex-wrap gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "absolute left-6 top-16 w-0.5 h-6 bg-gray-300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('experience.title')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experiences, (exp, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: exp.company,
          class: "relative"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(index + 1), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(exp.role), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(exp.year), 1)
              ]),
              _createElementVNode("h4", _hoisted_11, _toDisplayString(exp.company), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString(exp.description), 1),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exp.technologies, (tech) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: tech,
                    class: "bg-gray-200 text-gray-700 px-2 py-1 rounded text-sm"
                  }, _toDisplayString(tech), 1))
                }), 128))
              ])
            ])
          ]),
          (index < _ctx.experiences.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}